// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Calendar, PlusCircle, History, Car } from "lucide-react";
// import Cookies from "js-cookie";

// // Custom CSS
// const styles = `
// .dashboard-container {
//   min-height: 100vh;
//   padding: 20px;
// }

// .dashboard-content {
//   max-width: 1200px;
//   margin: 0 auto;
// }

// .dashboard-header {
//   background: linear-gradient(to right, #ff4b2b, #ff416c);
//   padding: 20px;
//   border-radius: 10px;
//   margin-bottom: 30px;
// }

// .dashboard-title {
//   color: white;
//   font-weight: bold;
//   margin: 0;
//   font-size: 2rem;
//   text-align: center;
//   text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
// }

// .dashboard-cards {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
// }

// .dashboard-card {
//   flex: 1;
//   min-width: 350px;
//   margin-bottom: 30px;
//   transition: transform 0.2s, box-shadow 0.2s;
// }

// .dashboard-card:hover {
//   transform: translateY(-5px);
//   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
//   cursor: pointer;
// }

// .card-body {
//   height: 120%;
//   width: 100%;
//   padding: 25px;
//   border-radius: 10px;
//   transition: all 0.3s ease;
// }

// .card-title {
//   margin-top: 15px;
//   font-size: 20px;
//   font-weight: 600;
// }

// .card-text {
//   margin-top: 10px;
//   font-size: 1.5rem;
// }

// .loading-spinner {
//   border: 8px solid rgba(0, 0, 0, 0.1);
//   border-top: 8px solid #3498db;
//   border-radius: 50%;
//   width: 60px;
//   height: 60px;
//   animation: spin 1s linear infinite;
//   margin: 50px auto;
// }

// @keyframes spin {
//   to {
//     transform: rotate(360deg);
//   }
// }

// @media (max-width: 768px) {
//   .dashboard-cards {
//     flex-direction: column;
//   }

//   .dashboard-card {
//     width: 100%;
//   }

//   .dashboard-header {
//     margin-bottom: 20px;
//   }
// }
// `;

// const DashboardCard = ({ title, description, icon: Icon, color, onClick }) => {
//   return (
//     <div className="dashboard-card" onClick={onClick}>
//       <div
//         className="card-body d-flex flex-column align-items-center text-center"
//         style={{
//           backgroundColor: color,
//           color: "white",
//         }}
//       >
//         <Icon size={48} />
//         <h5 className="card-title" style={{textShadow:"2px 2px 5px rgba(0,0,0,0.5)"}}>{title}</h5>
//         <p className="card-text"><b>{description}</b></p>
//       </div>
//     </div>
//   );
// };

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const [userType, setUserType] = useState();
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const userType = Cookies.get('adminUserType');

//       if (userType !== undefined) {
//         setUserType(userType);
//         setLoading(false);
//         clearInterval(interval);
//       }
//     }, 100);

//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (userType) {
//       setItems(userType === "dealer" ? dealerDashboardItems : (userType === "lender" ?  dashboardItems : privateLenderDashboardItems) );
//     }
//   }, [userType]);

//   const dashboardItems = [
//     {
//       title: "Upload Customer",
//       description: "Upload Customer Details for events",
//       icon: Calendar,
//       path: "/lenderUpload",
//       color: "#00b0f0",
//     },
//     {
//       title: "Create Event",
//       description: "Set up a new auction event",
//       icon: PlusCircle,
//       path: "/eventCreation",
//       color: "#00b050",
//     },
//     {
//       title: "Manage Events",
//       description: "View and manage all events",
//       icon: History,
//       path: "/lenderEvent",
//       color: "#ff0000",
//     },
//   ];

//   const dealerDashboardItems = [
//     {
//       title: "Car Upload",
//       description: "Upload Car Details, Images and Inspection Reports",
//       icon: Car,
//       path: "/carUpload",
//       color: "#00b0f0",
//     },
//     {
//       title: "Car Manage",
//       description: "Manage your car inventory",
//       icon: Car,
//       path: "/carManage",
//       color: "#00b050",
//     },
//     {
//       title: "Win History",
//       description: "View sold cars",
//       icon: Car,
//       path: "/winHistory",
//       color: "#ff0000",
//     },
    
//   ];

//   const privateLenderDashboardItems =[
//     {
//       title: "Create Event",
//       description: "Set up a new auction event",
//       icon: PlusCircle,
//       path: "/privateEvent",
//       color: "#10b981",
//     },
//     {
//       title: "Manage Events",
//       description: "View and manage all events",
//       icon: History,
//       path: "/lenderEvent",
//       color: "#ff0000",
//     },
//   ]
  
//   return (
//     <>
//       <style>{styles}</style>
//       <div className="dashboard-container">
//         <div className="dashboard-content">
//           <div className="dashboard-header">
//             <h5 className="dashboard-title">Welcome to eAuction Dashboard</h5>
//           </div>

//           {loading ? (
//             <div className="loading-spinner"></div>
//           ) : (
//             <div className="dashboard-cards">
//               {items.map((item) => (
//                 <DashboardCard
//                   key={item.path}
//                   title={item.title}
//                   description={item.description}
//                   icon={item.icon}
//                   color={item.color}
//                   onClick={() => navigate(item.path)}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, PlusCircle, History, Car } from "lucide-react";
import Cookies from "js-cookie";

// Custom CSS
const styles = `
.dashboard-container {
  height: 90vh;
  padding: 20px;
  overflow-y: auto; /* allow scrolling if cards overflow */
}

.dashboard-content {
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-header {
  background: linear-gradient(to right, #ff4b2b, #ff416c);
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.dashboard-title {
  color: white;
  font-weight: bold;
  margin: 0;
  font-size: 2rem;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.dashboard-card {
  flex: 1 1 calc(33.333% - 20px);
  max-width: 400px;
  margin-bottom: 30px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.card-body {
  width: 100%;
  height: 100%;
  padding: 25px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.card-title {
  margin-top: 15px;
  font-size: 20px;
  font-weight: 600;
}

.card-text {
  margin-top: 10px;
  font-size: 1.25rem;
  font-weight: 100;
}

.loading-spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin: 50px auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .dashboard-cards {
    flex-direction: column;
  }

  .dashboard-card {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }

  .dashboard-header {
    margin-bottom: 20px;
  }
}
`;

const DashboardCard = ({ title, description, icon: Icon, color, onClick }) => {
  return (
    <div className="dashboard-card" onClick={onClick}>
      <div
        className="card-body d-flex flex-column align-items-center text-center"
        style={{
          backgroundColor: color,
          color: "white",
        }}
      >
        <Icon size={48} />
        <h5
          className="card-title"
          style={{ textShadow: "2px 2px 5px rgba(0,0,0,0.5)" }}
        >
          {title}
        </h5>
        <p className="card-text">
          <b>{description}</b>
        </p>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      const userType = Cookies.get("adminUserType");

      if (userType !== undefined) {
        setUserType(userType);
        setLoading(false);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (userType) {
      setItems(
        userType === "dealer"
          ? dealerDashboardItems
          : userType === "lender"
          ? dashboardItems
          : privateLenderDashboardItems
      );
    }
  }, [userType]);

  const dashboardItems = [
    {
      title: "Upload Customer",
      description: "Upload Customer Details for events",
      icon: Calendar,
      path: "/lenderUpload",
      color: "#00b0f0",
    },
    {
      title: "Create Event",
      description: "Set up a new auction event",
      icon: PlusCircle,
      path: "/eventCreation",
      color: "#00b050",
    },
    {
      title: "Manage Events",
      description: "View and manage all events",
      icon: History,
      path: "/lenderEvent",
      color: "#ff0000",
    },
  ];

  const dealerDashboardItems = [
    {
      title: "Car Upload",
      description: "Upload Car Details, Images and Inspection Reports",
      icon: Car,
      path: "/carUpload",
      color: "#00b0f0",
    },
    {
      title: "Car Manage",
      description: "Manage your car inventory",
      icon: Car,
      path: "/carManage",
      color: "#00b050",
    },
    {
      title: "Win History",
      description: "View sold cars",
      icon: Car,
      path: "/winHistory",
      color: "#ff0000",
    },
  ];

  const privateLenderDashboardItems = [
    {
      title: "Create Event",
      description: "Set up a new bidding event",
      icon: PlusCircle,
      path: "/privateEvent",
      color: "#00aa4f",
    },
    {
      title: "Create Event Using Filter",
      description: "Create event using search available cars in the inventory",
      icon: Car,
      path: "/carSearch",
      color: "#0263cc" 
    },
    {
      title: "Manage Events",
      description: "View and manage all events",
      icon: History,
      path: "/lenderEvent",
      color: "#ff0000",
    }
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="dashboard-container">
        <div className="dashboard-content">
          <div className="dashboard-header">
            <h5 className="dashboard-title">Welcome to eBidding Dashboard</h5>
          </div>

          {loading ? (
            <div className="loading-spinner"></div>
          ) : (
            <div className="dashboard-cards">
              {items.map((item) => (
                <DashboardCard
                  key={item.path}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                  color={item.color}
                  onClick={() => navigate(item.path)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
